import axios from "axios";
import { apiBaseUrl } from "@/lib/env";

const publicApi = axios.create({
  baseURL: apiBaseUrl(),
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default publicApi;
